import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { Chip } from '../chip';
import { ComingSoonTagProps as Props } from './types';

export const ComingSoonTag = memo(
  ({ className, size = 'medium', fullWidth }: Props) => {
    return (
      <Chip
        className={classnames('ComingSoonTag', className)}
        size={size}
        label={'Coming Soon'}
        variant={'filled'}
        color="default"
        clickable={false}
        fullWidth={fullWidth}
      />
    );
  }
);

ComingSoonTag.displayName = 'ComingSoonTag';
